import React from "react";

const CultureSnapshot = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      tag: "CULTURE SNAPSHOT",
      title1: "We don’t just build portfolios.",
      title2: "We build people.",
      desc:
        "Our culture is rooted in mentorship, discipline, and purpose. Every consultant who joins JT Group enters an environment that celebrates growth, recognises achievement, and champions personal excellence.",
      btn: "Explore Careers →",
      culture: ["Mentorship", "Discipline", "Growth", "Excellence"],
    },

    zh: {
      tag: "企业文化",
      title1: "我们不仅打造财富组合",
      title2: "更培养人才",
      desc:
        "我们的文化建立在导师制、纪律与使命之上。加入 JT Group 的每位顾问都会进入一个鼓励成长、认可成就并追求卓越的环境。",
      btn: "查看招聘 →",
      culture: ["导师制", "纪律", "成长", "卓越"],
    },
  };

  const images = [
    "/assets/images/medium-shot-people-learning-job.jpg",
    "/assets/images/21515.jpg",
    "/assets/images/business-success-report-graph-concept.jpg",
    "/assets/images/strategy-business-brainstorming-graphic-concept.jpg",
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">

        {/* Left */}
        <div>
          <span className="text-[#C69C6D] text-sm font-bold tracking-wide">
            {text[lang].tag}
          </span>

          <h2 className="text-[34px] font-medium text-[#154059] leading-snug mt-4">
            {text[lang].title1} <br /> {text[lang].title2}
          </h2>

          <p className="text-gray-600 mt-5 leading-relaxed text-[15px]">
            {text[lang].desc}
          </p>

          <a
            href="/career"
            className="inline-block bg-[#C2976C] text-white px-8 py-3 font-semibold hover:bg-[#a88257] transition-colors duration-300 mt-6"
          >
            {text[lang].btn}
          </a>
        </div>


        {/* Right */}
        <div className="grid grid-cols-2 gap-4">

          {images.map((img, index) => (
            <div key={index} className="relative group overflow-hidden">

              <img
                src={img}
                alt=""
                className="w-full h-[150px] object-cover group-hover:scale-105 transition duration-300"
              />

              <div className="absolute bottom-0 left-0 w-full bg-black/30 text-white text-sm font-medium py-2 text-center">
                {text[lang].culture[index]}
              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default CultureSnapshot;